"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdxExportResult = exports.ScriptLines = exports.ScriptLineData = exports.ScriptListing = exports.ScriptFormatSummary = exports.ScriptFormat = exports.ScriptDocType = exports.SharedScriptStatus = void 0;
const zod_1 = require("zod");
const codex_1 = require("@showrunner/codex");
const common_1 = require("./common");
// While we migrate api away from using PRIVATE as a script status, this
// converts PRIVATE into OPEN for us on the client
exports.SharedScriptStatus = zod_1.z
    .enum(['OPEN', 'LIMITED', 'PRIVATE'])
    .transform((value) => (value === 'PRIVATE' ? 'OPEN' : value))
    .pipe(zod_1.z.enum(['OPEN', 'LIMITED']));
exports.ScriptDocType = zod_1.z.enum(['screenplay', 'variety', 'classic']);
exports.ScriptFormat = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    icon: zod_1.z.string(),
    definition: codex_1.FormatUtils.ZScriptConfiguration,
});
exports.ScriptFormatSummary = exports.ScriptFormat.omit({ definition: true });
exports.ScriptListing = zod_1.z.object({
    name: zod_1.z.string(),
    id: common_1.Uuid,
    folderId: common_1.Uuid,
    status: exports.SharedScriptStatus,
    type: exports.ScriptDocType,
    createdAt: common_1.SerializableDate,
    contentsModifiedAt: common_1.SerializableDate,
    contentsModifiedBy: common_1.Uuid,
    scriptFormat: exports.ScriptFormatSummary,
});
exports.ScriptLineData = zod_1.z.object({
    text: zod_1.z.string(),
    blockType: zod_1.z.string(),
    id: zod_1.z.string(),
});
exports.ScriptLines = zod_1.z.object({
    lines: zod_1.z.array(exports.ScriptLineData),
});
exports.FdxExportResult = zod_1.z.object({
    fdx: zod_1.z.string(),
});
